import type { MenuConfig } from '~typings/menu'

import { permissionTree as permisos, RESOURCE_PRODUCCION_PG } from '@/auth/permissions/modules/produccionPg'
import {
    ROUTE_PPG_CALIDAD,
    ROUTE_PPG_CATEGORIA,
    ROUTE_PPG_CERTIFICACION,
    ROUTE_PPG_CLASIFICACION,
    ROUTE_PPG_CONDICION,
    ROUTE_PPG_CONGELACION,
    ROUTE_PPG_EMPAQUE,
    ROUTE_PPG_ESPECIE,
    ROUTE_PPG_HIDRATACION,
    ROUTE_PPG_LINEA_PRODUCTO,
    ROUTE_PPG_MARCA,
    ROUTE_PPG_MASTER,
    ROUTE_PPG_PRESENTACION,
    ROUTE_PPG_PROCESO,
    ROUTE_PPG_PRODUCTO,
    ROUTE_PPG_SUBCONDICION,
    ROUTE_PPG_SUBPROCESO,
    ROUTE_PPG_SUBTIPO_PRODUCTO,
    ROUTE_PPG_TALLA,
    ROUTE_PPG_TIPO_PRODUCTO,
    ROUTE_PPG_TRATAMIENTO,
} from '@/router/routes/producion-pg/nombres'
import { defineMenu } from '@/utils/menu'

const { mantenimiento } = permisos
export default defineMenu([
    {
        title: 'produccion_pg.subopciones.categoria',
        resource: RESOURCE_PRODUCCION_PG,
        action: mantenimiento.categoria,
        route: ROUTE_PPG_CATEGORIA,
    },
    {
        title: 'produccion_pg.subopciones.tipo_producto',
        resource: RESOURCE_PRODUCCION_PG,
        action: mantenimiento.tipo_producto,
        route: ROUTE_PPG_TIPO_PRODUCTO,
    },
    {
        title: 'produccion_pg.subopciones.producto',
        resource: RESOURCE_PRODUCCION_PG,
        action: mantenimiento.producto,
        route: ROUTE_PPG_PRODUCTO,
    },
    {
        title: 'produccion_pg.subopciones.linea_producto',
        resource: RESOURCE_PRODUCCION_PG,
        action: mantenimiento.linea_producto,
        route: ROUTE_PPG_LINEA_PRODUCTO,
    },
    {
        title: 'produccion_pg.subopciones.subtipo_producto',
        resource: RESOURCE_PRODUCCION_PG,
        action: mantenimiento.subtipo_producto,
        route: ROUTE_PPG_SUBTIPO_PRODUCTO,
    },
    {
        title: 'produccion_pg.subopciones.talla',
        resource: RESOURCE_PRODUCCION_PG,
        action: mantenimiento.talla,
        route: ROUTE_PPG_TALLA,
        // children: [
        //     {
        //         title: 'produccion_pg.subopciones.talla',
        //         resource: RESOURCE_PRODUCCION_PG,
        //         action: mantenimiento.talla,
        //         route: ROUTE_PPG_TALLA,
        //     },
        //     {
        //         title: 'produccion_pg.subopciones.grupo_talla',
        //         resource: RESOURCE_PRODUCCION_PG,
        //         action: mantenimiento.grupo_talla,
        //         route: ROUTE_PPG_GRUPO_TALLA,
        //     },
        //     {
        //         title: 'produccion_pg.subopciones.tipo_talla',
        //         resource: RESOURCE_PRODUCCION_PG,
        //         action: mantenimiento.tipo_talla,
        //         route: ROUTE_PPG_TIPO_TALLA,
        //     },
        // ],
    },
    {
        title: 'produccion_pg.subopciones.calidad',
        resource: RESOURCE_PRODUCCION_PG,
        action: mantenimiento.calidad,
        route: ROUTE_PPG_CALIDAD,
    },
    // {
    //     title: 'produccion_pg.subopciones.grupo_talla',
    //     resource: RESOURCE_PRODUCCION_PG,
    //     action: mantenimiento.grupo_talla,
    //     route: ROUTE_PPG_GRUPO_TALLA,
    // },
    // {
    //     title: 'produccion_pg.subopciones.tipo_talla',
    //     resource: RESOURCE_PRODUCCION_PG,
    //     action: mantenimiento.tipo_talla,
    //     route: ROUTE_PPG_TIPO_TALLA,
    // },
    {
        title: 'produccion_pg.subopciones.presentacion',
        resource: RESOURCE_PRODUCCION_PG,
        action: mantenimiento.presentacion,
        route: ROUTE_PPG_PRESENTACION,
    },
    {
        title: 'produccion_pg.subopciones.proceso',
        resource: RESOURCE_PRODUCCION_PG,
        action: mantenimiento.proceso,
        route: ROUTE_PPG_PROCESO,
    },
    {
        title: 'produccion_pg.subopciones.subproceso',
        resource: RESOURCE_PRODUCCION_PG,
        action: mantenimiento.subproceso,
        route: ROUTE_PPG_SUBPROCESO,
    },
    {
        title: 'produccion_pg.subopciones.master',
        resource: RESOURCE_PRODUCCION_PG,
        action: mantenimiento.master,
        route: ROUTE_PPG_MASTER,
    },
    {
        title: 'produccion_pg.subopciones.empaque',
        resource: RESOURCE_PRODUCCION_PG,
        action: mantenimiento.empaque,
        route: ROUTE_PPG_EMPAQUE,
    },
    {
        title: 'produccion_pg.subopciones.especie',
        resource: RESOURCE_PRODUCCION_PG,
        action: mantenimiento.especie,
        route: ROUTE_PPG_ESPECIE,
    },
    {
        title: 'produccion_pg.subopciones.congelacion',
        resource: RESOURCE_PRODUCCION_PG,
        action: mantenimiento.congelacion,
        route: ROUTE_PPG_CONGELACION,
    },
    {
        title: 'produccion_pg.subopciones.hidratacion',
        resource: RESOURCE_PRODUCCION_PG,
        action: mantenimiento.hidratacion,
        route: ROUTE_PPG_HIDRATACION,
    },
    {
        title: 'produccion_pg.subopciones.clasificacion',
        resource: RESOURCE_PRODUCCION_PG,
        action: mantenimiento.clasificacion,
        route: ROUTE_PPG_CLASIFICACION,
    },
    {
        title: 'produccion_pg.subopciones.marca',
        resource: RESOURCE_PRODUCCION_PG,
        action: mantenimiento.marca,
        route: ROUTE_PPG_MARCA,
    },
    {
        title: 'produccion_pg.subopciones.condicion',
        resource: RESOURCE_PRODUCCION_PG,
        action: mantenimiento.condicion,
        route: ROUTE_PPG_CONDICION,
    },
    {
        title: 'produccion_pg.subopciones.subcondicion',
        resource: RESOURCE_PRODUCCION_PG,
        action: mantenimiento.subcondicion,
        route: ROUTE_PPG_SUBCONDICION,
    },
    {
        title: 'produccion_pg.subopciones.tratamiento',
        resource: RESOURCE_PRODUCCION_PG,
        action: mantenimiento.tratamiento,
        route: ROUTE_PPG_TRATAMIENTO,
    },
    {
        title: 'produccion_pg.subopciones.certificacion',
        resource: RESOURCE_PRODUCCION_PG,
        action: mantenimiento.certificacion,
        route: ROUTE_PPG_CERTIFICACION,
    },
] as MenuConfig[])
